import List from './list';
import Stocktake from '../models/stocktake';
import { excuseApi } from '../commons/http';

export const getStocktakes = async (params) => {
  const res = await excuseApi({
    path: '/stocktakes',
    method: 'GET',
    params,
  });
  return res.data;
};

export const createStocktake = async (data) => {
  const res = await excuseApi({
    path: '/stocktakes',
    method: 'POST',
    body: data,
  });
  return res.data;
};

export const updateStocktake = async (id, data) => {
  const res = await excuseApi({
    path: `/stocktakes/${id}`,
    method: 'PATCH',
    body: data,
  });
  return res.data;
};

export const deleteStocktake = async (id) => {
  const res = await excuseApi({
    path: `/stocktakes/${id}`,
    method: 'DELETE',
  });
  return res.data;
};

export const transitionStocktake = async (id, action, data = {}) => {
  const res = await excuseApi({
    path: `/stocktakes/${id}/${action}`,
    method: 'POST',
    body: data,
  });
  return res; // Return the full response including status
};

export const getStocktakeDetail = async (id) => {
  const res = await excuseApi({
    path: `/stocktakes/${id}`,
    method: 'GET',
  });
  return res; // Return the full response including status
};

export const updateStocktakeItem = async (stocktakeId, itemId, data) => {
  const res = await excuseApi({
    path: `/stocktakes/${stocktakeId}/items/${itemId}`,
    method: 'PATCH',
    body: data,
  });
  return res;
};

export const skipStocktakeItem = async (stocktakeId, itemId, data) => {
  const res = await excuseApi({
    path: `/stocktakes/${stocktakeId}/items/${itemId}/skip`,
    method: 'POST',
    body: data,
  });
  return res;
};

export default class Stocktakes extends List {
  async fetch(params = {}) {
    try {
      const res = await excuseApi({
        path: '/stocktakes',
        method: 'GET',
        params,
      });
      
      if (res.status === 200) {
        this.mapData(res.data.data || []);
        this.totalCount = res.data.total || 0;
        this.currentPage = res.data.page || 1;
        this.perPage = res.data.per_page || 10;
      }
      return res;
    } catch (error) {
      console.error('Error fetching stocktakes:', error);
      throw error;
    }
  }

  async create(data) {
    try {
      const res = await createStocktake(data);
      if (res.status === 201) {
        const stocktake = new Stocktake();
        stocktake.mapData(res.data);
        this.add(stocktake);
        return stocktake;
      }
      return res;
    } catch (error) {
      console.error('Error creating stocktake:', error);
      throw error;
    }
  }

  mapData(data = []) {
    this.clear(); // Clear existing items
    for (const item of data) {
      const stocktake = new Stocktake();
      stocktake.mapData(item);
      this.add(stocktake);
    }
  }

  // Filter methods
  filterByStatus(status) {
    return this.items.filter(stocktake => stocktake.status === status);
  }

  filterByCreator(accountId) {
    return this.items.filter(stocktake => stocktake.created_by_account_id === accountId);
  }

  // Sort methods
  sortByDate(ascending = false) {
    return [...this.items].sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return ascending ? dateA - dateB : dateB - dateA;
    });
  }

  sortByProgress(ascending = false) {
    return [...this.items].sort((a, b) => {
      const progressA = a.getProgressPercentage();
      const progressB = b.getProgressPercentage();
      return ascending ? progressA - progressB : progressB - progressA;
    });
  }
}